import React, { useState } from 'react'
import { Container,Row,Col } from 'react-bootstrap'
import './Add_installation.css'
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import {useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { MdDelete } from "react-icons/md";




export default function Payment({installDetails, setinstallDetails,}) {

const[isOpenPayment ,setIsOpenPayment] =useState(false);
  const [customerdelete, setcustomerdelete] = useState(false);
  const staffId = useSelector((state) => state.id);
console.log(installDetails,"installDetail")

const apiUrl = process.env.REACT_APP_API_BASE_URL;
      const locate = useLocation();

      const installationId = installDetails?._id; // 👈 extract it safely
  const staffName = useSelector((state) => state.staffname);

  
 const [originalData, setOriginalData] = useState({});

 const [selectedFile, setSelectedFile] = useState(null);

 const handleFileChange = (e) => {
  const files = Array.from(e.target.files); // make sure it's always an array
  setSelectedFile(files);
  console.log("Selected files:", files);
};


function formatDateToDDMMYYYY(dateString) {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}


  // This will log the updated state after render
  React.useEffect(() => {
    if (selectedFile) {
      console.log("Selected file from state:", selectedFile);
    }
  }, [selectedFile]);

 const [paymentData, setPaymentData] = useState({
    payType: "",
    payAmount: "",
    referenceNumber: "",
    updatedBy: staffName, // or set from login user
    updatedTime: new Date().toLocaleTimeString(),
    updatedDate: new Date().toLocaleDateString(),
  });

  const[isOpenThreeDots,setIsOpenThreeDots]=useState(false);
 
const handleSubmit = async (e) => {
  e.preventDefault();

  const result = await Swal.fire({
    title: "Do you want to save the Payment Details?",
    showCancelButton: true,
    confirmButtonText: "Save",
  });

  if (!result.isConfirmed) return;

  try {
    // ✅ Validation
    if (!paymentData.payType || !paymentData.payAmount || !paymentData.referenceNumber) {
      return Swal.fire("Missing fields", "Please fill all required payment fields", "warning");
    }
    if (isNaN(Number(paymentData.payAmount))) {
      return Swal.fire("Invalid Amount", "Pay Amount must be a number", "warning");
    }

    // 1️⃣ Append to payment.items but keep payment.images intact
    const existingItems = installDetails?.payment?.items || [];
    const existingImages = installDetails?.payment?.images || [];

    // Calculate order value to check if fully paid
    const planMonth = Number(installDetails?.installplanDetails?.installplanMonth) || 0;
    const planAmount = Number(installDetails?.installplanDetails?.installplanAmount) || 0;
    const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost) || 0;
    const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost) || 0;
    const routerCost = Number(installDetails?.installplanDetails?.installrouterCost) || 0;
    const otherCost = Number(installDetails?.installplanDetails?.installothersCost) || 0;
    const baseAmount = (planMonth * planAmount) + staticIpCost + installationCost + routerCost + otherCost;
    const orderValue = +(baseAmount + (baseAmount * 0.18)).toFixed(2);

    const currentTotalPayment = existingItems.reduce(
      (sum, item) => sum + Number(item.payAmount || 0),
      0
    );
    const newTotalPayment = currentTotalPayment + Number(paymentData.payAmount);
    const isFullyPaid = newTotalPayment >= orderValue;

    const fullPayment = {
      isCompleted: isFullyPaid,
      items: [
        ...existingItems,
        {
          ...paymentData,
          updatedBy: staffName,
          updatedTime: new Date().toLocaleTimeString(),
          updatedDate: new Date().toLocaleDateString(),
        },
      ],
      images: existingImages, // preserve old images
    };

    const updatedInstall = {
      ...installDetails,
      payment: fullPayment,
    };

    // --- Save payment and get updated document ---
    const paymentRes = await axios.post(
      `${apiUrl}/update-lead-install`,
      updatedInstall,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    let updatedDetails = paymentRes.data.updatedDocument || installDetails;

    // 2️⃣ Upload Images (append to payment.images)
    if (selectedFile && selectedFile.length > 0) {
      const formData = new FormData();
      formData.append("type", "installation");
      formData.append("id", installationId);
      formData.append("staffId", staffId);
      formData.append("staffName", staffName);

      selectedFile.forEach((file) => {
        if (file instanceof File) {
          formData.append("images", file);
        }
      });

      const imageRes = await axios.post(`${apiUrl}/payment/images/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      // If backend returns updated doc after image upload, replace details
      if (imageRes.data.updatedDocument) {
        updatedDetails = imageRes.data.updatedDocument;
      }
    }

    // ✅ Update local state so UI reflects latest changes
    setinstallDetails(updatedDetails);

    Swal.fire("Success!", "Payment and images saved successfully", "success");

    // Reset form
    setPaymentData({
      payType: "",
      payAmount: "",
      referenceNumber: "",
      updatedBy: "",
      updatedTime: "",
      updatedDate: "",
    });
    setSelectedFile([]);
    setIsOpenPayment(false);

  } catch (error) {
    console.error("Submit Error:", error);
    Swal.fire("Error", error.response?.data?.message || "Something went wrong!", "error");
  }
};





    const handleChange = (e) => {
        const { name, value } = e.target;
        setPaymentData(prev => ({
          ...prev,
          [name]: value
        }));
      };
    
  // useEffect(() => {
  //       axios
  //         .post(apiUrl+"getdata-install", {
  //           leadId: locate.state?.leadId,
  //         })
  //         .then((res) => {
  //           setinstallDetails(res.data.message);
  //           setOriginalData(res.data.message); // Store original data for comparison
  //         });
  //     }, [locate.state?.leadId]);

    //   const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setinstallDetails((prev) => ({
    //       ...prev,
    //       payment: {
    //         ...prev.payment,
    //         [name]: value,
    //       },
    //     }));


    
        const planMonth = Number(installDetails?.installplanDetails?.installplanMonth)||0;
const planAmount = Number(installDetails?.installplanDetails?.installplanAmount)||0;
const staticIpCost = Number(installDetails?.installplanDetails?.installstaticIpCost)||0;
const installationCost = Number(installDetails?.installplanDetails?.installinstalationCost)||0;
const routerCost = Number(installDetails?.installplanDetails?.installrouterCost)||0;
const otherCost = Number(installDetails?.installplanDetails?.installothersCost)||0;

const totalPlanAmount = planMonth * planAmount;

const baseAmount = totalPlanAmount + staticIpCost + installationCost + routerCost + otherCost;

const gstAmount = baseAmount * 0.18;


const orderValue = +(baseAmount + gstAmount).toFixed(2);


const formattedOrderValue = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(orderValue);


const plan = installDetails.installplanDetails || {};


const installrouterCost = Number(plan.routerSellingCost) || 0;
const installfiberCost = Number(plan.installfiberCost) || 0;
const installfiberCableMeter = Number(plan.installfiberCableMeter) || 0;
const installottPrice = Array.isArray(plan.installottPrice) ? Number(plan.installottPrice[0]) || 0 : 0;
const installothersCost = Number(plan.installothersCost) || 0;
const OrderScore = baseAmount
  - installrouterCost
  - (installfiberCableMeter * installfiberCost)
  - installottPrice
  - installothersCost;

console.log("OrderScore:", OrderScore);
console.log(baseAmount,'baseamout')

const formattedOrderScore = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR"
}).format(OrderScore);

    
    const handleDelete = async (installationId, referenceNumber) => {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "you want to delete this data!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      });
    
      if (result.isConfirmed) {
        try {
          await axios.delete(apiUrl+`${installationId}/payment/by-reference/${referenceNumber}`);
          Swal.fire("Deleted!", "Your data has been deleted.", "success");
          setcustomerdelete(true);
        } catch (error) {
          Swal.fire("Error!", "Something went wrong while deleting.", "error");
          console.error("Delete Error:", error);
        }
      }
    };
    
    const isPaymentAvailable = installDetails?.payment?.items.length > 0;


const totalPaymentAmount = installDetails?.payment?.items?.reduce(
  (sum, item) => sum + Number(item.payAmount || 0),
  0
);

const dueAmount =orderValue - totalPaymentAmount;


  return (
    <div>
        <Container>
            {/* <form> */}



                <Row>
                    <Col md={9} sm={19} >
         <div  className='plan-details-container-border mt-3 text-center ' style={{width:"70%"}}>
                            <p style={{ fontSize:"13px"}}  className='pt-2'><span className='text-primary'>{installDetails?.installplanDetails?.installfiberCableMeter}
                            </span> M, <span className='text-primary '>{installDetails?.installplanDetails?.installplanSpeed}
                            </span> Mbps, <span className='text-primary'> {installDetails?.installplanDetails?.installplanMonth}</span>Month @ <span className='text-primary'>Rs. {installDetails?.installplanDetails?.installplanAmount}
                            /-</span></p>
                            <p  style={{ fontSize:"13px"}}>Order Value @ <span className='text-primary'>Rs.{formattedOrderValue}/-</span>, OrderScore @ <span className='text-primary'>Rs.{formattedOrderScore}/-</span></p>
                            
                        </div>
                    
   </Col >
   </Row>
   {!isPaymentAvailable && (
   <div className='modal-payment1 mt-5'>
                <Container>
                    <div>

                    <Row className='mb-3'>
                        <Col className=''> <h5>Pay</h5></Col>
                        {/* <Col className='text-end'><span style={{fontSize:"23px"}} onClick={()=>setIsOpenPayment(false)}><strong>&times;</strong>   </span> </Col> */}
                    </Row>
                    <Row>
                        <Col>
                        <div>
                        <label className='text-start'>
                            <p>Pay Type</p>
                        </label>
                        <br/>
                        <select
                                                                            
                                                                            class=" form-input-select payment-select-option mt-2 "
                                                                            value={paymentData.payType}
                                                                            name="payType"
                                                                            onChange={handleChange}
                                                                        >
                                                                            <option value="">Select Type</option>
                                                                            <option
                                                                                

                                                                                value="Private"
                                                                            >
                                                                                Private
                                                                            </option>
                                                                            <option  value="Technology">
                                                                                Technology
                                                                            </option>
                                                                            <option  value="Cash">
                                                                                cash
                                                                            </option>
                                                                            <option  value="Helpdesk">
                                                                                Helpdesk
                                                                            </option>
                                                                            <option  value="Others">
                                                                            Others
                                                                            </option>
                                                                        </select>
                                                                        </div>
                        </Col>

                        <Col>
                        <div >
                            <label>Pay Amount</label>
                            {/* <br/> */}
                            <input  className='form-input'
                            placeholder='Rs.'  value={paymentData.payAmount}
                            onChange={handleChange}
                            name="payAmount"/>
                           
                        </div>
                        </Col>
                    </Row>
                    <Row>
                        <label>Reference Number</label>
                        <br/>
                        <input className='form-input  payment-reference' placeholder='Enter Reference Number' type="text"
                        value={paymentData.referenceNumber}
                        onChange={handleChange}
                        name="referenceNumber"/>
                    </Row>
                    <Row>
                    <input
                    type="file"
                    // variant="light"
                    className="btn-upload   file-upload form-input payment-reference "
                    style={{ height: "45px" }}
                    onChange={handleFileChange}
                    placeholder='upload file'
                    
                    
                  />
                    </Row>
                    <div className='text-end'>

                    <button  type="button" className='blue-btn' onClick={handleSubmit} > Submit</button>
                    </div>

                    </div>
                
                </Container>
            </div>
   )}
   

    



   {installDetails?.payment?.items.length > 0 && (
  <>
    {/* Add Payment Button */}
    <div className='add-payment-intall'>
      <Row>
      <Col md={3} sm={3} className="text-end">
        <div className="text-end " >
          <button
            type="button"
            className="add-payment-install bg-warning"
            onClick={() => setIsOpenPayment(true)}
          >
            Add Payment
          </button>

          {/* Modal */}
          {isOpenPayment && (
            <div className="overlay-payment">
              <div className="modal-payment">
                <Container>
                  <Row>
                    <Col className='text-start'>
                      <h5>Pay</h5>
                    </Col>
                    <Col className="text-end">
                      <span
                        style={{ fontSize: "23px" }}
                        onClick={() => setIsOpenPayment(false)}
                      >
                        <strong>&times;</strong>
                      </span>
                    </Col>
                  </Row>

                  <Row className='text-start'>
                    <Col>
                      <div>
                        <label className="text-start">
                          <p>Pay Type</p>
                        </label>
                        <select className="form-input-select payment-select-option mt-2"
                        value={paymentData.payType}
                        name="payType"
                        onChange={handleChange}>
                          <option value="">Select Type</option>
                          <option value="Private">Private</option>
                          <option value="Technology">Technology</option>
                          <option value="Cash">Cash</option>
                          <option value="Helpdesk">Helpdesk</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                    </Col>

                    <Col>
                      <div>
                        <label>Pay Amount</label>
                        <input className="form-input" placeholder="Rs."
                        value={paymentData.payAmount}
                        name="payAmount"
                        onChange={handleChange} />
                      </div>
                    </Col>
                  </Row>

                  <Row className='text-start'>
                    <label>Reference Number</label>
                    <input
                      className="form-input payment-reference"
                      placeholder="Enter Reference Number"
                      type="text"
                      value={paymentData.referenceNumber}
                        name="referenceNumber"
                       onChange={handleChange}
                    />
                  </Row>

                  <Row>
                    <input
                      type="file"
                      className="btn-upload file-upload form-input payment-reference"
                      style={{ height: "45px" }}
                                          onChange={handleFileChange}

                    />
                  </Row>
                  <div className='text-end'>

<button  type="button" className='blue-btn' onClick={handleSubmit} > Submit</button>
</div>


                  
                </Container>
              </div>
            </div>
          )}
        </div>
       
      </Col>
      </Row>
    </div>

    {/* Order Info */}
    <div className="text-center mt-5">
      <p>
        Order Value @ <span>Rs.{orderValue}/-</span> , Order Score @{" "}
        <span className="green-ruppes-payment">Rs. {formattedOrderScore}/-</span>
      </p>
    </div>

    {/* Payment Table */}
    <div className="mt-5">
      <table className="table table-bordered">
        <thead className="table-th text-center">
          <tr>
            <th className="table-th-content">Sl.No</th>
            <th className="table-th-content">Date</th>
            <th className="table-th-content">Type</th>
            <th className="table-th-content">Reference No</th>
            <th className="table-th-content">Amount</th>
            {/* <th className="table-th-content">Delete</th> */}
          </tr>
        </thead>
        <tbody>
          {installDetails.payment.items.map((pay, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{pay.updatedDate}</td>
              <td>{pay.payType}</td>
              <td>{pay.referenceNumber}</td>
              <td>Rs. {pay.payAmount}</td>
              {/* <td
                className="text-center"
                onClick={() => handleDelete(installationId, pay.referenceNumber)}
              >
                <MdDelete size={20} />
              </td> */}
            </tr>
          ))}
        </tbody>
      </table>

      {/* Due Amount */}
      <div className="due-amount-container">
        <span className="due-label">Due Amount</span>
        <span className="due-amount">Rs. {dueAmount}/-</span>
      </div>
    </div>

    {/* Transaction Photos */}
    <div className="payment-photo-container">
  <label className="mt-4 ms-5">
    <strong>Transaction Photos ({installDetails?.payment?.images?.length || 0})</strong>
  </label>

  <Row className="ms-5 me-5">
    {installDetails?.payment?.images?.map((img, index) => (

      
      <Col key={index} xs={6} md={4} lg={3} className='px-4'>
        {/* Image */}
        <Row className="mt-4 ">
          <img
            src={img.image}
            alt={`Payment-${index}`}
            style={{
              width: "100%",
              height: "150px",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ddd",
            }}
          />
        </Row>

        {/* Info */}
        <Row>
          <p style={{ fontSize: "10px", marginTop: "5px",textAlign:"center" }}>
            By <span className="text-primary">{img.staffName}</span>{" "}
            <span>
              {formatDateToDDMMYYYY(img.uploadedDate)}
            </span>
          </p>
        </Row>
      </Col>
    ))}
  </Row>
</div>

  </>
)}

            {/* </form> */}
        </Container>
    </div>
  )
}

